import { Quote, Star, ArrowUpRight } from "lucide-react";
import { TESTIMONIALS } from "../../data";
import Reveal from "./Reveal";

const Testimonials = () => (
  <section className="pb-24 lg:pb-32" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 border-t border-white/10 pt-16">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400 mb-3">Ils m'ont fait confiance</p>
            <h3 className="font-display font-bold tracking-tight text-xl sm:text-3xl">
              Ce que mes clients <span className="text-blue-500">en disent</span>
            </h3>
          </div>
          <div className="flex items-center gap-1" data-testid="testimonials-rating">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={14} className="fill-blue-500 text-blue-500" />
            ))}
            <span className="ml-2 font-mono text-xs text-zinc-500 uppercase tracking-wider">5/5 — 100% satisfaits</span>
          </div>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.1}>
            <figure
              className={`group relative h-full flex flex-col rounded-2xl border border-white/10 bg-[#111115] p-7 sm:p-8 hover:border-blue-500/40 transition-colors duration-500 ${
                i === 1 ? "md:-translate-y-4" : ""
              }`}
              data-testid={`testimonial-card-${t.id}`}
            >
              <Quote size={28} className="text-blue-500/40 mb-5" />
              <blockquote className="text-zinc-300 text-sm sm:text-base leading-relaxed flex-1">« {t.quote} »</blockquote>
              <figcaption className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between gap-4">
                <div>
                  <p className="font-display font-semibold text-white">{t.name}</p>
                  <p className="font-mono text-[11px] uppercase tracking-wider text-zinc-500 mt-1">{t.role}</p>
                </div>
                <a
                  href={t.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visiter le site de ${t.name}`}
                  className="w-9 h-9 shrink-0 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 group-hover:border-blue-500 group-hover:text-white hover:bg-blue-500 transition-colors duration-300"
                  data-testid={`testimonial-link-${t.id}`}
                >
                  <ArrowUpRight size={16} />
                </a>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
